'use client'
import { Global, css } from '@emotion/react'

const globalStyles = css`
  @font-face {
    font-family: 'Nunito Variable';
    font-style: normal;
    font-display: swap;
    font-weight: 200 1000;
    src: url('/fonts/nunito-latin-wght-normal.woff2') format('woff2-variations');
    unicode-range: U+00??, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Sofia Sans Variable';
    font-style: normal;
    font-display: swap;
    font-weight: 1 1000;
    src: url('/fonts/sofia-sans-latin-wght-normal.woff2') format('woff2-variations');
    unicode-range: U+00??, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Plus Jakarta Sans Variable';
    font-style: normal;
    font-display: swap;
    font-weight: 200 800;
    src: url('/fonts/plus-jakarta-sans-latin-wght-normal.woff2') format('woff2-variations');
    unicode-range: U+00??, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  html {
    scroll-behavior: smooth;
  }
  html,
  body {
    overscroll-behavior: none;
    overflow-x: clip;
  }
  body {
    font-family: 'Nunito Variable', 'Sofia Sans Variable', 'Helvetica', 'Arial', sans-serif !important;
    font-variant-ligatures: none;
  }
`

export default function GlobalStyles() {
  return <Global styles={globalStyles} />
}
